module.exports = __webpack_public_path__ + "static/media/orga2.48966871.svg";